<style scoped>
.modal-dialog {
	z-index: 1060;
}

.modal-backdrop {
	z-index: 1050;
}

.symbol-icon {
	display: block;
	height: 22px;
	width: auto;
	max-width: 36px;
	object-fit: contain;
}
</style>

<template>
	<div
		v-if="modelValue"
		class="modal fade show d-block"
		tabindex="-1"
		@click.self="$emit('update:modelValue', false)"
	>
		<div class="modal-dialog modal-dialog-centered modal-lg">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title">
						<i class="bi bi-question-circle me-2"></i>MapVision Review Help
					</h5>
					<button
						type="button"
						class="btn-close"
						@click="$emit('update:modelValue', false)"
					></button>
				</div>
				<div class="modal-body">
					<h6>Site Type Symbols</h6>
					<p class="small text-muted">
						Each site on the map is drawn with MapVision's own symbol for its
						site type. MapVision also varies some symbols by sub-type and
						inspection history, which our tile payload does not carry, so the
						map shows each type's own default symbol.
					</p>
					<table class="table table-sm table-bordered small mb-3">
						<thead class="table-light">
							<tr>
								<th style="width: 20px"></th>
								<th>Site type</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="[type, symbol] in symbolRows" :key="type">
								<td>
									<img class="symbol-icon" :src="symbol.url" :alt="type" />
								</td>
								<td class="fw-semibold">{{ type }}</td>
							</tr>
							<tr>
								<td>
									<img
										class="symbol-icon"
										:src="defaultSymbol.url"
										alt="Other / unknown type"
									/>
								</td>
								<td class="text-muted">Other / unknown type</td>
							</tr>
						</tbody>
					</table>

					<h6>Selecting Sites</h6>
					<p class="small text-muted mb-0">
						Click a site dot on the map to view its full details. The site panel
						opens on the left; click the house icon on the map edge to collapse
						or reopen it.
					</p>
				</div>
			</div>
		</div>
		<div class="modal-backdrop fade show"></div>
	</div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import {
	MAPVISION_DEFAULT_SITE_SYMBOL,
	MAPVISION_SITE_TYPE_SYMBOLS,
} from "@/lib/mapvision";

defineProps<{
	modelValue: boolean;
}>();

defineEmits<{
	"update:modelValue": [value: boolean];
}>();

const symbolRows = computed(() => Object.entries(MAPVISION_SITE_TYPE_SYMBOLS));
const defaultSymbol = MAPVISION_DEFAULT_SITE_SYMBOL;
</script>
